<div mat-dialog-title>
  <span>{{ 'PROFILE.LANGUAGE_DIALOG_TITLE' | translate }}</span>
  <q9-dialog-close-button (click)="onClose()"></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <div class="language-suggestion-content">
    <p>{{ 'PROFILE.LANGUAGE_DETECTED_MESSAGE' | translate: {language: suggestedLanguageTitle} }}</p>
    <p>{{ 'PROFILE.LANGUAGE_INSTRUCTION' | translate }}</p>
    <p>{{ 'PROFILE.LANGUAGE_GUIDANCE' | translate }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button (click)="onKeepCurrent()">
    {{ 'PROFILE.LANGUAGE_KEEP_BTN' | translate }}
  </q9-secondary-button>

  <q9-primary-button (click)="onNavigateToProfile()">
    {{ 'PROFILE.LANGUAGE_GO_TO_PROFILE' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
